(()=>{'use strict';
const roots=()=>[...document.querySelectorAll('[data-tgsa]')];
function init(root){
 if(root.dataset.tgsaReady==='true')return;
 root.dataset.tgsaReady='true';
 const drawers=[...root.querySelectorAll('[data-tgsa-drawer]')];
 const closeAll=()=>{drawers.forEach(d=>d.setAttribute('aria-hidden','true'));document.body.classList.remove('tgsa-drawer-open')};
 root.querySelectorAll('[data-tgsa-open]').forEach(btn=>btn.addEventListener('click',()=>{
   const drawer=root.querySelector(`[data-tgsa-drawer="${btn.dataset.tgsaOpen}"]`);
   if(!drawer)return;
   closeAll();drawer.setAttribute('aria-hidden','false');document.body.classList.add('tgsa-drawer-open');
   drawer.querySelector('.tgsa-drawer__header button')?.focus();
 }));
 root.querySelectorAll('[data-tgsa-close]').forEach(btn=>btn.addEventListener('click',closeAll));
 document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll()});
 root.querySelectorAll('[data-tgsa-sort-select]').forEach(select=>select.addEventListener('change',()=>select.form?.submit()));
 root.querySelectorAll('[data-tgsa-auto-submit] input').forEach(input=>input.addEventListener('change',()=>input.form?.submit()));
 const mobileSortForm=root.querySelector('[data-tgsa-mobile-sort-form]');
 const mobileSortInput=root.querySelector('[data-tgsa-mobile-sort-input]');
 root.querySelectorAll('[data-sort-value]').forEach(btn=>btn.addEventListener('click',()=>{
   if(!mobileSortForm||!mobileSortInput)return;
   mobileSortInput.value=btn.dataset.sortValue||'best-selling';
   mobileSortForm.submit();
 }));
 const more=root.querySelector('[data-tgsa-load-more]');
 if(more)more.addEventListener('click',async()=>{
   if(more.disabled||!more.dataset.nextUrl)return;
   const original=more.textContent;
   more.disabled=true;more.textContent=more.dataset.loadingText||'Loading…';
   try{
     const nextUrl=new URL(more.dataset.nextUrl,location.origin);nextUrl.searchParams.set('view','shop-all');
     const response=await fetch(nextUrl.href,{headers:{'X-Requested-With':'XMLHttpRequest'}});
     if(!response.ok)throw new Error(`HTTP ${response.status}`);
     const html=await response.text();
     const doc=new DOMParser().parseFromString(html,'text/html');
     const incoming=doc.querySelector('[data-tgsa-products]');
     const target=root.querySelector('[data-tgsa-products]');
     if(!incoming||!target)throw new Error('Products not found');
     [...incoming.children].forEach(node=>target.appendChild(node));
     const next=doc.querySelector('[data-tgsa-load-more]');
     if(next?.dataset.nextUrl){
       more.dataset.nextUrl=next.dataset.nextUrl;
       more.disabled=false;more.textContent=original;
     }else{
       more.remove();
     }
     document.dispatchEvent(new CustomEvent('tgsa:products-loaded',{detail:{root}}));
   }catch(error){
     console.error('[Tangible Shop All]',error);
     more.disabled=false;more.textContent=original;
   }
 });
}
function initAll(){roots().forEach(init)}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',initAll,{once:true}):initAll();
document.addEventListener('shopify:section:load',initAll);
window.TangibleShopAll={refresh:initAll};
})();